export default class EmrState {

}
